export default __webpack_public_path__ + "static/media/pakkapati 4.cd20e14d.PNG";